import { render, staticRenderFns } from "./operate-auth.vue?vue&type=template&id=ce6dd396&"
import script from "./operate-auth.vue?vue&type=script&lang=js&"
export * from "./operate-auth.vue?vue&type=script&lang=js&"
import style0 from "./operate-auth.vue?vue&type=style&index=0&id=ce6dd396&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports